import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Table, TableBody, TableCell, TableRow, TableHead, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function ProgressTrackingViewDialog({ open, onClose, sheetId, getDocument }) {
    const [docData, setDocData] = useState([]);

    useEffect(() => {
        if (open && sheetId) {
            getDocument(sheetId).then((sections) => {
                setDocData(sections || []);
            });
        }
    }, [open, sheetId, getDocument]);

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            keepMounted
            disableRestoreFocus
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
                onClose();
            }}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                工作進度檢視
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {docData.length === 0 ? (
                    <Typography color="textSecondary">尚無資料</Typography>
                ) : (
                    docData.map((section) => (
                        <Box
                            key={section.id}
                            mb={3}
                            border={1}
                            borderColor="#ddd"
                            borderRadius={2}
                        >
                            <Box bgcolor="#cae3e8" p={1}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ fontWeight: "bold" }}
                                >
                                    {section.name}
                                </Typography>
                            </Box>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: "bold" }}>項目</TableCell>
                                        <TableCell style={{ fontWeight: "bold" }}>達成情況/規劃</TableCell>
                                        <TableCell style={{ fontWeight: "bold" }}>
                                            執行進度說明及後續規劃
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(section.columns || []).map((col) => (
                                        <TableRow key={col.id}>
                                            {/* 項目 */}
                                            <TableCell style={{ width: "20%" }}>
                                                {col.name}
                                            </TableCell>

                                            {/* 達成情況/規劃 */}
                                            <TableCell style={{ width: '40%', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                                                {col.achievement_status_plan_content || "-"}
                                            </TableCell>

                                            {/* 執行進度說明及後續規劃 */}
                                            <TableCell style={{ width: '40%', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                                                {col.implementation_progress_content || "-"}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    ))
                )}
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    style={{
                        backgroundColor: "#fff",
                        color: "#555",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                    }}
                >
                    關閉
                </Button>
            </DialogActions>
        </Dialog>
    );
}
